import { useState } from 'react'

import { toggleArray } from '@domain-group/javascript-utils'

import useProviderPackageItem from '@hooks/useProviderPackageItem'

import type { ActionResult } from '@redux/modules/types'

import {
  ProviderPackageItemModel, ProviderPriceListItemModel, ProviderPriceListModel, ServiceProductModel,
} from '@models/types'

type Option = {
  id: number,
  title: string,
  value: {
    id: number,
    price: number,
    title: string,
  },
}

type ProductSelectorState = {
  selectedItem: ProviderPriceListItemModel,
  selectedOptions: Option[],
  selectedPriceList: ProviderPriceListModel,
  selectedProduct: ServiceProductModel,
}

const mapStateToEntityState = (state: ProductSelectorState, provider_package_id: number) => {
  const {
    selectedItem,
    selectedOptions,
    selectedPriceList,
    selectedProduct,
  } = state

  const providerPackageItemParams = {
    options: JSON.stringify(selectedOptions),
    provider_package_id,
    provider_price_list_id: selectedPriceList.id,
    provider_price_list_item_id: selectedItem.id,
    service_id: selectedProduct.service_id,
    service_product_id: selectedProduct.id,
  }

  return providerPackageItemParams
}

type ResponseObject = {
  response: ActionResult<ProviderPackageItemModel>,
}

const toggleId = (responseObject: ResponseObject, setAddedProductIds: Function) => {
  const { response } = responseObject
  // @ts-expect-error TS2339
  const { success, data } = response || {}

  if (success){
    // @ts-expect-error TS7006
    setAddedProductIds(prevState => toggleArray(prevState, data.id))
  }
}

type UseCreateProviderPackageItemModalParams = {
  providerPackageItem: ProviderPackageItemModel,
  state: ProductSelectorState,
}

// @ts-expect-error TS2739
const useCreateProviderPackageItemModal = (params: UseCreateProviderPackageItemModalParams = {}) => {
  const { providerPackageItem, state } = params

  const [addedProductIds, setAddedProductIds] = useState<number[]>([])

  // @ts-expect-error TS2339
  const { provider_id, provider_package_id } = providerPackageItem || {}

  const {
    selectedItem,
    selectedOptions,
    selectedPriceList,
    selectedProduct,
  } = state

  const {
    callbacks: {
      createProviderPackageItem,
    },
    creating,
  } = useProviderPackageItem()

  const saveEnabled = !!(
    selectedPriceList?.id
    && selectedProduct.id
    && selectedItem.id
    && selectedItem.options?.length === selectedOptions.length
  )

  const hasAssignedProviderPackageItems = !!addedProductIds.length

  return {
    addedProductIds,
    callbacks: {
      createProviderPackageItem,
      mapStateToEntityState: () => mapStateToEntityState(state, provider_package_id),
      toggleId: (responseObject: { response: ActionResult<ProviderPackageItemModel> }) => (
        toggleId(responseObject, setAddedProductIds)
      ),
    },
    creating,
    hasAssignedProviderPackageItems,
    providerId: provider_id,
    providerPackageItem,
    saveEnabled,
    setAddedProductIds,
  }
}

export default useCreateProviderPackageItemModal
